<template>
	<div>
		<div
			class="modal fade"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
			data-focus="false"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div
						class="modal-header modal-header-banner"
						:style="eventBannerStyle"
					>
						<button
							type="button"
							class="modal-close"
							@click="close"
							aria-label="Close"
						>
							<i class="sk-icon-times"></i>
						</button>
					</div>
					<div class="modal-body">
						<loading :active="loading" />
						<div class="modal-inner-content">
							<h1 class="modal-title">{{ title }}</h1>
							<h2 class="modal-subtitle">
								{{ description }}
							</h2>
							<button
								class="button button-primary"
								@click="viewMenuClicked"
							>
								Place Order
							</button>
							<button
								v-if="showGuestCheckout"
								class="button button-text"
								@click="guestCheckoutClicked"
							>
								<span>
									Not a
									{{ businessName }}
									Resident?
									<b>Order here.</b>
								</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-header-banner {
	height: 220px;
}

.modal-title {
	font-size: 18px;
	text-align: center;
}

.modal-subtitle {
	font-size: 14px;
	color: var(--sk-grey3);
	text-align: center;
	margin-bottom: 26px;
}

.button-text {
	margin: 22px auto 0 auto;
	max-width: 100% !important;
	height: auto;
}

.button-text span {
	color: var(--sk-grey3);
}
</style>

<script>
import Loading from "vue-loading-overlay"
import eventDetailsMixin from "@/mixins/event-details-mixin"

export default {
	name: "OngoingPopupEventModal",
	mixins: [eventDetailsMixin],
	components: {
		Loading
	},
	data: function () {
		return {
			eventId: 0
		}
	},
	computed: {
		showGuestCheckout() {
			return this.$store.state.user && this.$store.state.user.id != 0
				? false
				: true
		},
		loading() {
			return this.title.length <= 0
		},
		event() {
			if (this.eventId && this.$store.state.businessEvents) {
				return this.$store.state.businessEvents.find(
					(menu) => menu.id == this.eventId
				)
			}
			return null
		},
		title() {
			if (this.event) {
				return `${this.eventName} Popup is Here!`
			}
			return ""
		},
		description() {
			return "Order now & earn points towards future orders - or visit the popup downstairs and place an order on-site."
		},
		businessName() {
			return this.$store.state.business
				? this.$store.state.business.name
				: ""
		}
	},
	methods: {
		open(options) {
			let isModalOpen = $(this.$refs.modal).is(":visible")
			if (isModalOpen) {
				return
			}
			this.eventId = options.eventId
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Ongoing Event Modal CTA Opened",
				data: {
					eventId: this.eventId
				}
			})
			this.$store.dispatch("markFlag", {
				flag: "displayedUpcomingModal",
				value: true
			})
			$(this.$refs.modal).modal("show")
		},
		viewMenuClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Ongoing Event Modal CTA Clicked",
				data: {
					eventId: this.eventId
				}
			})
			this.$router.push({
				path: `/${this.$route.params.slug}/menu/event/${this.eventId}`
			})
			this.close()
		},
		guestCheckoutClicked() {
			this.$store.dispatch("markFlag", {
				flag: "isGuestCheckoutActive",
				value: true
			})
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Ongoing Event Modal Guest Checkout Clicked",
				data: {
					eventId: this.eventId
				}
			})
			this.$router.push({
				path: `/${this.$route.params.slug}/menu/event/${this.eventId}`
			})
			this.close()
		},
		close() {
			$(this.$refs.modal).modal("hide")
		}
	}
}
</script>